export const industryWieghts: {
  [key: number]: {
    [key: string]: number;
  };
} = {
  1: {
    OIL_GAS_PETROCHEMICAL: 0.02,
    RENEWABLE_ENERGY: 0.04,
    PLASTIC_RUBBER: 0.03,
    WOOD_FURNITURE: 0.03,
    AUTOMOTIVE_TRANSPORT: 0.03,
    PHARMA_BIOTECH_MEDICAL: 0.04,
    ELECTRONICS_HARDWARE: 0.04,
    CHEMICAL_PETROCHEMICAL: 0.03,
    FOOD_AGRICULTURE: 0.03,
    METALS_METALLURGY: 0.03,
    PAPER_PRINTING: 0.02,
    INDUSTRIAL_MACHINERY: 0.03,
    NON_METALLIC_MINERALS: 0.02,
    TEXTILE_APPAREL: 0.03,
    SOFTWARE_IT: 0.04,
    SOFTWARE_IT_DATACENTER: 0.04,
    AEROSPACE_DEFENSE: 0.03,
    OTHER: 0.03,
  },
  2: {
    OIL_GAS_PETROCHEMICAL: 0.04,
    RENEWABLE_ENERGY: 0.03,
    PLASTIC_RUBBER: 0.03,
    WOOD_FURNITURE: 0.03,
    AUTOMOTIVE_TRANSPORT: 0.03,
    PHARMA_BIOTECH_MEDICAL: 0.04,
    ELECTRONICS_HARDWARE: 0.03,
    CHEMICAL_PETROCHEMICAL: 0.03,
    FOOD_AGRICULTURE: 0.04,
    METALS_METALLURGY: 0.03,
    PAPER_PRINTING: 0.03,
    INDUSTRIAL_MACHINERY: 0.03,
    NON_METALLIC_MINERALS: 0.03,
    TEXTILE_APPAREL: 0.03,
    SOFTWARE_IT: 0.04,
    SOFTWARE_IT_DATACENTER: 0.04,
    AEROSPACE_DEFENSE: 0.04,
    OTHER: 0.03,
  },
  3: {
    OIL_GAS_PETROCHEMICAL: 0.04,
    RENEWABLE_ENERGY: 0.02,
    PLASTIC_RUBBER: 0.03,
    WOOD_FURNITURE: 0.03,
    AUTOMOTIVE_TRANSPORT: 0.04,
    PHARMA_BIOTECH_MEDICAL: 0.02,
    ELECTRONICS_HARDWARE: 0.02,
    CHEMICAL_PETROCHEMICAL: 0.03,
    FOOD_AGRICULTURE: 0.03,
    METALS_METALLURGY: 0.04,
    PAPER_PRINTING: 0.04,
    INDUSTRIAL_MACHINERY: 0.03,
    NON_METALLIC_MINERALS: 0.04,
    TEXTILE_APPAREL: 0.03,
    SOFTWARE_IT: 0.02,
    SOFTWARE_IT_DATACENTER: 0.02,
    AEROSPACE_DEFENSE: 0.02,
    OTHER: 0.03,
  },
  4: {
    OIL_GAS_PETROCHEMICAL: 0.04,
    RENEWABLE_ENERGY: 0.03,
    PLASTIC_RUBBER: 0.03,
    WOOD_FURNITURE: 0.03,
    AUTOMOTIVE_TRANSPORT: 0.03,
    PHARMA_BIOTECH_MEDICAL: 0.02,
    ELECTRONICS_HARDWARE: 0.03,
    CHEMICAL_PETROCHEMICAL: 0.03,
    FOOD_AGRICULTURE: 0.03,
    METALS_METALLURGY: 0.04,
    PAPER_PRINTING: 0.03,
    INDUSTRIAL_MACHINERY: 0.03,
    NON_METALLIC_MINERALS: 0.04,
    TEXTILE_APPAREL: 0.03,
    SOFTWARE_IT: 0.02,
    SOFTWARE_IT_DATACENTER: 0.03,
    AEROSPACE_DEFENSE: 0.03,
    OTHER: 0.03,
  },
  5: {
    OIL_GAS_PETROCHEMICAL: 0.02,
    RENEWABLE_ENERGY: 0.03,
    PLASTIC_RUBBER: 0.03,
    WOOD_FURNITURE: 0.03,
    AUTOMOTIVE_TRANSPORT: 0.02,
    PHARMA_BIOTECH_MEDICAL: 0.03,
    ELECTRONICS_HARDWARE: 0.03,
    CHEMICAL_PETROCHEMICAL: 0.03,
    FOOD_AGRICULTURE: 0.03,
    METALS_METALLURGY: 0.02,
    PAPER_PRINTING: 0.03,
    INDUSTRIAL_MACHINERY: 0.03,
    NON_METALLIC_MINERALS: 0.02,
    TEXTILE_APPAREL: 0.03,
    SOFTWARE_IT: 0.04,
    SOFTWARE_IT_DATACENTER: 0.03,
    AEROSPACE_DEFENSE: 0.03,
    OTHER: 0.03,
  },
  6: {
    OIL_GAS_PETROCHEMICAL: 0.02,
    RENEWABLE_ENERGY: 0.02,
    PLASTIC_RUBBER: 0.03,
    WOOD_FURNITURE: 0.03,
    AUTOMOTIVE_TRANSPORT: 0.02,
    PHARMA_BIOTECH_MEDICAL: 0.02,
    ELECTRONICS_HARDWARE: 0.02,
    CHEMICAL_PETROCHEMICAL: 0.02,
    FOOD_AGRICULTURE: 0.02,
    METALS_METALLURGY: 0.02,
    PAPER_PRINTING: 0.03,
    INDUSTRIAL_MACHINERY: 0.02,
    NON_METALLIC_MINERALS: 0.02,
    TEXTILE_APPAREL: 0.03,
    SOFTWARE_IT: 0.02,
    SOFTWARE_IT_DATACENTER: 0.02,
    AEROSPACE_DEFENSE: 0.02,
    OTHER: 0.02,
  },
  7: {
    OIL_GAS_PETROCHEMICAL: 0.02,
    RENEWABLE_ENERGY: 0.02,
    PLASTIC_RUBBER: 0.02,
    WOOD_FURNITURE: 0.01,
    AUTOMOTIVE_TRANSPORT: 0.02,
    PHARMA_BIOTECH_MEDICAL: 0.02,
    ELECTRONICS_HARDWARE: 0.02,
    CHEMICAL_PETROCHEMICAL: 0.02,
    FOOD_AGRICULTURE: 0.02,
    METALS_METALLURGY: 0.02,
    PAPER_PRINTING: 0.01,
    INDUSTRIAL_MACHINERY: 0.02,
    NON_METALLIC_MINERALS: 0.02,
    TEXTILE_APPAREL: 0.02,
    SOFTWARE_IT: 0.02,
    SOFTWARE_IT_DATACENTER: 0.02,
    AEROSPACE_DEFENSE: 0.02,
    OTHER: 0.02,
  },
  8: {
    OIL_GAS_PETROCHEMICAL: 0.02,
    RENEWABLE_ENERGY: 0.02,
    PLASTIC_RUBBER: 0.02,
    WOOD_FURNITURE: 0.01,
    AUTOMOTIVE_TRANSPORT: 0.02,
    PHARMA_BIOTECH_MEDICAL: 0.02,
    ELECTRONICS_HARDWARE: 0.02,
    CHEMICAL_PETROCHEMICAL: 0.02,
    FOOD_AGRICULTURE: 0.02,
    METALS_METALLURGY: 0.02,
    PAPER_PRINTING: 0.01,
    INDUSTRIAL_MACHINERY: 0.02,
    NON_METALLIC_MINERALS: 0.01,
    TEXTILE_APPAREL: 0.02,
    SOFTWARE_IT: 0.02,
    SOFTWARE_IT_DATACENTER: 0.02,
    AEROSPACE_DEFENSE: 0.02,
    OTHER: 0.02,
  },
  9: {
    OIL_GAS_PETROCHEMICAL: 0.02,
    RENEWABLE_ENERGY: 0.03,
    PLASTIC_RUBBER: 0.03,
    WOOD_FURNITURE: 0.03,
    AUTOMOTIVE_TRANSPORT: 0.02,
    PHARMA_BIOTECH_MEDICAL: 0.03,
    ELECTRONICS_HARDWARE: 0.03,
    CHEMICAL_PETROCHEMICAL: 0.02,
    FOOD_AGRICULTURE: 0.02,
    METALS_METALLURGY: 0.02,
    PAPER_PRINTING: 0.02,
    INDUSTRIAL_MACHINERY: 0.02,
    NON_METALLIC_MINERALS: 0.02,
    TEXTILE_APPAREL: 0.03,
    SOFTWARE_IT: 0.03,
    SOFTWARE_IT_DATACENTER: 0.02,
    AEROSPACE_DEFENSE: 0.03,
    OTHER: 0.03,
  },
  10: {
    OIL_GAS_PETROCHEMICAL: 0.02,
    RENEWABLE_ENERGY: 0.02,
    PLASTIC_RUBBER: 0.02,
    WOOD_FURNITURE: 0.02,
    AUTOMOTIVE_TRANSPORT: 0.02,
    PHARMA_BIOTECH_MEDICAL: 0.02,
    ELECTRONICS_HARDWARE: 0.02,
    CHEMICAL_PETROCHEMICAL: 0.02,
    FOOD_AGRICULTURE: 0.02,
    METALS_METALLURGY: 0.02,
    PAPER_PRINTING: 0.02,
    INDUSTRIAL_MACHINERY: 0.02,
    NON_METALLIC_MINERALS: 0.02,
    TEXTILE_APPAREL: 0.02,
    SOFTWARE_IT: 0.02,
    SOFTWARE_IT_DATACENTER: 0.02,
    AEROSPACE_DEFENSE: 0.02,
    OTHER: 0.02,
  },
  11: {
    OIL_GAS_PETROCHEMICAL: 0.02,
    RENEWABLE_ENERGY: 0.02,
    PLASTIC_RUBBER: 0.02,
    WOOD_FURNITURE: 0.02,
    AUTOMOTIVE_TRANSPORT: 0.02,
    PHARMA_BIOTECH_MEDICAL: 0.01,
    ELECTRONICS_HARDWARE: 0.02,
    CHEMICAL_PETROCHEMICAL: 0.02,
    FOOD_AGRICULTURE: 0.02,
    METALS_METALLURGY: 0.02,
    PAPER_PRINTING: 0.02,
    INDUSTRIAL_MACHINERY: 0.02,
    NON_METALLIC_MINERALS: 0.02,
    TEXTILE_APPAREL: 0.02,
    SOFTWARE_IT: 0.01,
    SOFTWARE_IT_DATACENTER: 0.01,
    AEROSPACE_DEFENSE: 0.02,
    OTHER: 0.02,
  },
  12: {
    OIL_GAS_PETROCHEMICAL: 0.02,
    RENEWABLE_ENERGY: 0.02,
    PLASTIC_RUBBER: 0.02,
    WOOD_FURNITURE: 0.02,
    AUTOMOTIVE_TRANSPORT: 0.02,
    PHARMA_BIOTECH_MEDICAL: 0.01,
    ELECTRONICS_HARDWARE: 0.02,
    CHEMICAL_PETROCHEMICAL: 0.02,
    FOOD_AGRICULTURE: 0.02,
    METALS_METALLURGY: 0.02,
    PAPER_PRINTING: 0.02,
    INDUSTRIAL_MACHINERY: 0.02,
    NON_METALLIC_MINERALS: 0.02,
    TEXTILE_APPAREL: 0.02,
    SOFTWARE_IT: 0.01,
    SOFTWARE_IT_DATACENTER: 0.02,
    AEROSPACE_DEFENSE: 0.02,
    OTHER: 0.02,
  },
  13: {
    OIL_GAS_PETROCHEMICAL: 0.01,
    RENEWABLE_ENERGY: 0.02,
    PLASTIC_RUBBER: 0.02,
    WOOD_FURNITURE: 0.02,
    AUTOMOTIVE_TRANSPORT: 0.02,
    PHARMA_BIOTECH_MEDICAL: 0.02,
    ELECTRONICS_HARDWARE: 0.02,
    CHEMICAL_PETROCHEMICAL: 0.01,
    FOOD_AGRICULTURE: 0.01,
    METALS_METALLURGY: 0.01,
    PAPER_PRINTING: 0.02,
    INDUSTRIAL_MACHINERY: 0.02,
    NON_METALLIC_MINERALS: 0.01,
    TEXTILE_APPAREL: 0.02,
    SOFTWARE_IT: 0.03,
    SOFTWARE_IT_DATACENTER: 0.02,
    AEROSPACE_DEFENSE: 0.02,
    OTHER: 0.02,
  },
  14: {
    OIL_GAS_PETROCHEMICAL: 0.01,
    RENEWABLE_ENERGY: 0.02,
    PLASTIC_RUBBER: 0.02,
    WOOD_FURNITURE: 0.02,
    AUTOMOTIVE_TRANSPORT: 0.02,
    PHARMA_BIOTECH_MEDICAL: 0.02,
    ELECTRONICS_HARDWARE: 0.02,
    CHEMICAL_PETROCHEMICAL: 0.01,
    FOOD_AGRICULTURE: 0.01,
    METALS_METALLURGY: 0.01,
    PAPER_PRINTING: 0.02,
    INDUSTRIAL_MACHINERY: 0.02,
    NON_METALLIC_MINERALS: 0.01,
    TEXTILE_APPAREL: 0.02,
    SOFTWARE_IT: 0.02,
    SOFTWARE_IT_DATACENTER: 0.02,
    AEROSPACE_DEFENSE: 0.02,
    OTHER: 0.02,
  },
  15: {
    OIL_GAS_PETROCHEMICAL: 0.01,
    RENEWABLE_ENERGY: 0.02,
    PLASTIC_RUBBER: 0.02,
    WOOD_FURNITURE: 0.02,
    AUTOMOTIVE_TRANSPORT: 0.02,
    PHARMA_BIOTECH_MEDICAL: 0.02,
    ELECTRONICS_HARDWARE: 0.02,
    CHEMICAL_PETROCHEMICAL: 0.02,
    FOOD_AGRICULTURE: 0.02,
    METALS_METALLURGY: 0.01,
    PAPER_PRINTING: 0.02,
    INDUSTRIAL_MACHINERY: 0.02,
    NON_METALLIC_MINERALS: 0.01,
    TEXTILE_APPAREL: 0.02,
    SOFTWARE_IT: 0.02,
    SOFTWARE_IT_DATACENTER: 0.02,
    AEROSPACE_DEFENSE: 0.02,
    OTHER: 0.02,
  },
  16: {
    OIL_GAS_PETROCHEMICAL: 0.02,
    RENEWABLE_ENERGY: 0.02,
    PLASTIC_RUBBER: 0.02,
    WOOD_FURNITURE: 0.02,
    AUTOMOTIVE_TRANSPORT: 0.01,
    PHARMA_BIOTECH_MEDICAL: 0.02,
    ELECTRONICS_HARDWARE: 0.02,
    CHEMICAL_PETROCHEMICAL: 0.02,
    FOOD_AGRICULTURE: 0.02,
    METALS_METALLURGY: 0.02,
    PAPER_PRINTING: 0.02,
    INDUSTRIAL_MACHINERY: 0.02,
    NON_METALLIC_MINERALS: 0.02,
    TEXTILE_APPAREL: 0.01,
    SOFTWARE_IT: 0.01,
    SOFTWARE_IT_DATACENTER: 0.02,
    AEROSPACE_DEFENSE: 0.02,
    OTHER: 0.02,
  },
  17: {
    OIL_GAS_PETROCHEMICAL: 0.02,
    RENEWABLE_ENERGY: 0.02,
    PLASTIC_RUBBER: 0.02,
    WOOD_FURNITURE: 0.02,
    AUTOMOTIVE_TRANSPORT: 0.01,
    PHARMA_BIOTECH_MEDICAL: 0.01,
    ELECTRONICS_HARDWARE: 0.02,
    CHEMICAL_PETROCHEMICAL: 0.02,
    FOOD_AGRICULTURE: 0.02,
    METALS_METALLURGY: 0.02,
    PAPER_PRINTING: 0.02,
    INDUSTRIAL_MACHINERY: 0.02,
    NON_METALLIC_MINERALS: 0.02,
    TEXTILE_APPAREL: 0.02,
    SOFTWARE_IT: 0.01,
    SOFTWARE_IT_DATACENTER: 0.01,
    AEROSPACE_DEFENSE: 0.02,
    OTHER: 0.02,
  },
  18: {
    OIL_GAS_PETROCHEMICAL: 0.02,
    RENEWABLE_ENERGY: 0.01,
    PLASTIC_RUBBER: 0.02,
    WOOD_FURNITURE: 0.02,
    AUTOMOTIVE_TRANSPORT: 0.01,
    PHARMA_BIOTECH_MEDICAL: 0.02,
    ELECTRONICS_HARDWARE: 0.01,
    CHEMICAL_PETROCHEMICAL: 0.01,
    FOOD_AGRICULTURE: 0.02,
    METALS_METALLURGY: 0.03,
    PAPER_PRINTING: 0.02,
    INDUSTRIAL_MACHINERY: 0.02,
    NON_METALLIC_MINERALS: 0.04,
    TEXTILE_APPAREL: 0.02,
    SOFTWARE_IT: 0.01,
    SOFTWARE_IT_DATACENTER: 0.01,
    AEROSPACE_DEFENSE: 0.02,
    OTHER: 0.02,
  },
  19: {
    OIL_GAS_PETROCHEMICAL: 0.04,
    RENEWABLE_ENERGY: 0.03,
    PLASTIC_RUBBER: 0.04,
    WOOD_FURNITURE: 0.04,
    AUTOMOTIVE_TRANSPORT: 0.04,
    PHARMA_BIOTECH_MEDICAL: 0.03,
    ELECTRONICS_HARDWARE: 0.03,
    CHEMICAL_PETROCHEMICAL: 0.03,
    FOOD_AGRICULTURE: 0.04,
    METALS_METALLURGY: 0.04,
    PAPER_PRINTING: 0.04,
    INDUSTRIAL_MACHINERY: 0.03,
    NON_METALLIC_MINERALS: 0.04,
    TEXTILE_APPAREL: 0.03,
    SOFTWARE_IT: 0.03,
    SOFTWARE_IT_DATACENTER: 0.03,
    AEROSPACE_DEFENSE: 0.03,
    OTHER: 0.03,
  },
  20: {
    OIL_GAS_PETROCHEMICAL: 0.03,
    RENEWABLE_ENERGY: 0.03,
    PLASTIC_RUBBER: 0.03,
    WOOD_FURNITURE: 0.04,
    AUTOMOTIVE_TRANSPORT: 0.03,
    PHARMA_BIOTECH_MEDICAL: 0.02,
    ELECTRONICS_HARDWARE: 0.03,
    CHEMICAL_PETROCHEMICAL: 0.03,
    FOOD_AGRICULTURE: 0.03,
    METALS_METALLURGY: 0.03,
    PAPER_PRINTING: 0.04,
    INDUSTRIAL_MACHINERY: 0.03,
    NON_METALLIC_MINERALS: 0.03,
    TEXTILE_APPAREL: 0.04,
    SOFTWARE_IT: 0.03,
    SOFTWARE_IT_DATACENTER: 0.03,
    AEROSPACE_DEFENSE: 0.03,
    OTHER: 0.03,
  },
  21: {
    OIL_GAS_PETROCHEMICAL: 0.03,
    RENEWABLE_ENERGY: 0.03,
    PLASTIC_RUBBER: 0.03,
    WOOD_FURNITURE: 0.03,
    AUTOMOTIVE_TRANSPORT: 0.03,
    PHARMA_BIOTECH_MEDICAL: 0.04,
    ELECTRONICS_HARDWARE: 0.04,
    CHEMICAL_PETROCHEMICAL: 0.03,
    FOOD_AGRICULTURE: 0.03,
    METALS_METALLURGY: 0.03,
    PAPER_PRINTING: 0.03,
    INDUSTRIAL_MACHINERY: 0.03,
    NON_METALLIC_MINERALS: 0.03,
    TEXTILE_APPAREL: 0.03,
    SOFTWARE_IT: 0.04,
    SOFTWARE_IT_DATACENTER: 0.04,
    AEROSPACE_DEFENSE: 0.04,
    OTHER: 0.03,
  },
  22: {
    OIL_GAS_PETROCHEMICAL: 0.02,
    RENEWABLE_ENERGY: 0.04,
    PLASTIC_RUBBER: 0.02,
    WOOD_FURNITURE: 0.02,
    AUTOMOTIVE_TRANSPORT: 0.03,
    PHARMA_BIOTECH_MEDICAL: 0.04,
    ELECTRONICS_HARDWARE: 0.04,
    CHEMICAL_PETROCHEMICAL: 0.04,
    FOOD_AGRICULTURE: 0.02,
    METALS_METALLURGY: 0.02,
    PAPER_PRINTING: 0.02,
    INDUSTRIAL_MACHINERY: 0.03,
    NON_METALLIC_MINERALS: 0.02,
    TEXTILE_APPAREL: 0.02,
    SOFTWARE_IT: 0.04,
    SOFTWARE_IT_DATACENTER: 0.03,
    AEROSPACE_DEFENSE: 0.04,
    OTHER: 0.03,
  },
  23: {
    OIL_GAS_PETROCHEMICAL: 0.02,
    RENEWABLE_ENERGY: 0.04,
    PLASTIC_RUBBER: 0.03,
    WOOD_FURNITURE: 0.03,
    AUTOMOTIVE_TRANSPORT: 0.03,
    PHARMA_BIOTECH_MEDICAL: 0.03,
    ELECTRONICS_HARDWARE: 0.03,
    CHEMICAL_PETROCHEMICAL: 0.03,
    FOOD_AGRICULTURE: 0.03,
    METALS_METALLURGY: 0.03,
    PAPER_PRINTING: 0.03,
    INDUSTRIAL_MACHINERY: 0.03,
    NON_METALLIC_MINERALS: 0.02,
    TEXTILE_APPAREL: 0.03,
    SOFTWARE_IT: 0.04,
    SOFTWARE_IT_DATACENTER: 0.03,
    AEROSPACE_DEFENSE: 0.03,
    OTHER: 0.03,
  },
  24: {
    OIL_GAS_PETROCHEMICAL: 0.06,
    RENEWABLE_ENERGY: 0.03,
    PLASTIC_RUBBER: 0.05,
    WOOD_FURNITURE: 0.05,
    AUTOMOTIVE_TRANSPORT: 0.05,
    PHARMA_BIOTECH_MEDICAL: 0.04,
    ELECTRONICS_HARDWARE: 0.03,
    CHEMICAL_PETROCHEMICAL: 0.04,
    FOOD_AGRICULTURE: 0.04,
    METALS_METALLURGY: 0.06,
    PAPER_PRINTING: 0.05,
    INDUSTRIAL_MACHINERY: 0.04,
    NON_METALLIC_MINERALS: 0.06,
    TEXTILE_APPAREL: 0.05,
    SOFTWARE_IT: 0.03,
    SOFTWARE_IT_DATACENTER: 0.03,
    AEROSPACE_DEFENSE: 0.03,
    OTHER: 0.04,
  },
  25: {
    OIL_GAS_PETROCHEMICAL: 0.07,
    RENEWABLE_ENERGY: 0.05,
    PLASTIC_RUBBER: 0.07,
    WOOD_FURNITURE: 0.07,
    AUTOMOTIVE_TRANSPORT: 0.05,
    PHARMA_BIOTECH_MEDICAL: 0.04,
    ELECTRONICS_HARDWARE: 0.05,
    CHEMICAL_PETROCHEMICAL: 0.06,
    FOOD_AGRICULTURE: 0.06,
    METALS_METALLURGY: 0.07,
    PAPER_PRINTING: 0.06,
    INDUSTRIAL_MACHINERY: 0.06,
    NON_METALLIC_MINERALS: 0.07,
    TEXTILE_APPAREL: 0.07,
    SOFTWARE_IT: 0.04,
    SOFTWARE_IT_DATACENTER: 0.05,
    AEROSPACE_DEFENSE: 0.05,
    OTHER: 0.06,
  },
  26: {
    OIL_GAS_PETROCHEMICAL: 0.02,
    RENEWABLE_ENERGY: 0.07,
    PLASTIC_RUBBER: 0.04,
    WOOD_FURNITURE: 0.04,
    AUTOMOTIVE_TRANSPORT: 0.05,
    PHARMA_BIOTECH_MEDICAL: 0.07,
    ELECTRONICS_HARDWARE: 0.07,
    CHEMICAL_PETROCHEMICAL: 0.04,
    FOOD_AGRICULTURE: 0.04,
    METALS_METALLURGY: 0.03,
    PAPER_PRINTING: 0.03,
    INDUSTRIAL_MACHINERY: 0.05,
    NON_METALLIC_MINERALS: 0.03,
    TEXTILE_APPAREL: 0.04,
    SOFTWARE_IT: 0.08,
    SOFTWARE_IT_DATACENTER: 0.07,
    AEROSPACE_DEFENSE: 0.07,
    OTHER: 0.05,
  },
  27: {
    OIL_GAS_PETROCHEMICAL: 0.03,
    RENEWABLE_ENERGY: 0.03,
    PLASTIC_RUBBER: 0.03,
    WOOD_FURNITURE: 0.04,
    AUTOMOTIVE_TRANSPORT: 0.05,
    PHARMA_BIOTECH_MEDICAL: 0.04,
    ELECTRONICS_HARDWARE: 0.04,
    CHEMICAL_PETROCHEMICAL: 0.03,
    FOOD_AGRICULTURE: 0.04,
    METALS_METALLURGY: 0.03,
    PAPER_PRINTING: 0.04,
    INDUSTRIAL_MACHINERY: 0.03,
    NON_METALLIC_MINERALS: 0.03,
    TEXTILE_APPAREL: 0.03,
    SOFTWARE_IT: 0.04,
    SOFTWARE_IT_DATACENTER: 0.04,
    AEROSPACE_DEFENSE: 0.03,
    OTHER: 0.04,
  },
  28: {
    OIL_GAS_PETROCHEMICAL: 0.07,
    RENEWABLE_ENERGY: 0.05,
    PLASTIC_RUBBER: 0.06,
    WOOD_FURNITURE: 0.06,
    AUTOMOTIVE_TRANSPORT: 0.05,
    PHARMA_BIOTECH_MEDICAL: 0.05,
    ELECTRONICS_HARDWARE: 0.05,
    CHEMICAL_PETROCHEMICAL: 0.06,
    FOOD_AGRICULTURE: 0.06,
    METALS_METALLURGY: 0.07,
    PAPER_PRINTING: 0.07,
    INDUSTRIAL_MACHINERY: 0.05,
    NON_METALLIC_MINERALS: 0.07,
    TEXTILE_APPAREL: 0.06,
    SOFTWARE_IT: 0.04,
    SOFTWARE_IT_DATACENTER: 0.05,
    AEROSPACE_DEFENSE: 0.04,
    OTHER: 0.06,
  },
  29: {
    OIL_GAS_PETROCHEMICAL: 0.04,
    RENEWABLE_ENERGY: 0.03,
    PLASTIC_RUBBER: 0.03,
    WOOD_FURNITURE: 0.03,
    AUTOMOTIVE_TRANSPORT: 0.03,
    PHARMA_BIOTECH_MEDICAL: 0.03,
    ELECTRONICS_HARDWARE: 0.02,
    CHEMICAL_PETROCHEMICAL: 0.03,
    FOOD_AGRICULTURE: 0.03,
    METALS_METALLURGY: 0.03,
    PAPER_PRINTING: 0.03,
    INDUSTRIAL_MACHINERY: 0.03,
    NON_METALLIC_MINERALS: 0.03,
    TEXTILE_APPAREL: 0.03,
    SOFTWARE_IT: 0.02,
    SOFTWARE_IT_DATACENTER: 0.03,
    AEROSPACE_DEFENSE: 0.03,
    OTHER: 0.03,
  },
  30: {
    OIL_GAS_PETROCHEMICAL: 0.04,
    RENEWABLE_ENERGY: 0.03,
    PLASTIC_RUBBER: 0.03,
    WOOD_FURNITURE: 0.03,
    AUTOMOTIVE_TRANSPORT: 0.03,
    PHARMA_BIOTECH_MEDICAL: 0.02,
    ELECTRONICS_HARDWARE: 0.02,
    CHEMICAL_PETROCHEMICAL: 0.03,
    FOOD_AGRICULTURE: 0.03,
    METALS_METALLURGY: 0.04,
    PAPER_PRINTING: 0.03,
    INDUSTRIAL_MACHINERY: 0.03,
    NON_METALLIC_MINERALS: 0.04,
    TEXTILE_APPAREL: 0.03,
    SOFTWARE_IT: 0.02,
    SOFTWARE_IT_DATACENTER: 0.02,
    AEROSPACE_DEFENSE: 0.02,
    OTHER: 0.03,
  },
  31: {
    OIL_GAS_PETROCHEMICAL: 0.03,
    RENEWABLE_ENERGY: 0.03,
    PLASTIC_RUBBER: 0.03,
    WOOD_FURNITURE: 0.03,
    AUTOMOTIVE_TRANSPORT: 0.03,
    PHARMA_BIOTECH_MEDICAL: 0.03,
    ELECTRONICS_HARDWARE: 0.03,
    CHEMICAL_PETROCHEMICAL: 0.03,
    FOOD_AGRICULTURE: 0.03,
    METALS_METALLURGY: 0.03,
    PAPER_PRINTING: 0.03,
    INDUSTRIAL_MACHINERY: 0.03,
    NON_METALLIC_MINERALS: 0.03,
    TEXTILE_APPAREL: 0.02,
    SOFTWARE_IT: 0.03,
    SOFTWARE_IT_DATACENTER: 0.03,
    AEROSPACE_DEFENSE: 0.03,
    OTHER: 0.03,
  },
  32: {
    OIL_GAS_PETROCHEMICAL: 0.01,
    RENEWABLE_ENERGY: 0.03,
    PLASTIC_RUBBER: 0.02,
    WOOD_FURNITURE: 0.02,
    AUTOMOTIVE_TRANSPORT: 0.03,
    PHARMA_BIOTECH_MEDICAL: 0.03,
    ELECTRONICS_HARDWARE: 0.04,
    CHEMICAL_PETROCHEMICAL: 0.02,
    FOOD_AGRICULTURE: 0.02,
    METALS_METALLURGY: 0.02,
    PAPER_PRINTING: 0.03,
    INDUSTRIAL_MACHINERY: 0.03,
    NON_METALLIC_MINERALS: 0.01,
    TEXTILE_APPAREL: 0.02,
    SOFTWARE_IT: 0.04,
    SOFTWARE_IT_DATACENTER: 0.03,
    AEROSPACE_DEFENSE: 0.03,
    OTHER: 0.03,
  },
  33: {
    OIL_GAS_PETROCHEMICAL: 0.03,
    RENEWABLE_ENERGY: 0.04,
    PLASTIC_RUBBER: 0.03,
    WOOD_FURNITURE: 0.03,
    AUTOMOTIVE_TRANSPORT: 0.03,
    PHARMA_BIOTECH_MEDICAL: 0.02,
    ELECTRONICS_HARDWARE: 0.02,
    CHEMICAL_PETROCHEMICAL: 0.03,
    FOOD_AGRICULTURE: 0.03,
    METALS_METALLURGY: 0.03,
    PAPER_PRINTING: 0.03,
    INDUSTRIAL_MACHINERY: 0.02,
    NON_METALLIC_MINERALS: 0.03,
    TEXTILE_APPAREL: 0.03,
    SOFTWARE_IT: 0.02,
    SOFTWARE_IT_DATACENTER: 0.02,
    AEROSPACE_DEFENSE: 0.02,
    OTHER: 0.03,
  },
  34: {
    OIL_GAS_PETROCHEMICAL: 0.03,
    RENEWABLE_ENERGY: 0.02,
    PLASTIC_RUBBER: 0.03,
    WOOD_FURNITURE: 0.03,
    AUTOMOTIVE_TRANSPORT: 0.02,
    PHARMA_BIOTECH_MEDICAL: 0.02,
    ELECTRONICS_HARDWARE: 0.02,
    CHEMICAL_PETROCHEMICAL: 0.03,
    FOOD_AGRICULTURE: 0.03,
    METALS_METALLURGY: 0.03,
    PAPER_PRINTING: 0.03,
    INDUSTRIAL_MACHINERY: 0.03,
    NON_METALLIC_MINERALS: 0.03,
    TEXTILE_APPAREL: 0.03,
    SOFTWARE_IT: 0.02,
    SOFTWARE_IT_DATACENTER: 0.02,
    AEROSPACE_DEFENSE: 0.02,
    OTHER: 0.02,
  },
  35: {
    OIL_GAS_PETROCHEMICAL: 0.01,
    RENEWABLE_ENERGY: 0.01,
    PLASTIC_RUBBER: 0.02,
    WOOD_FURNITURE: 0.02,
    AUTOMOTIVE_TRANSPORT: 0.02,
    PHARMA_BIOTECH_MEDICAL: 0.02,
    ELECTRONICS_HARDWARE: 0.02,
    CHEMICAL_PETROCHEMICAL: 0.02,
    FOOD_AGRICULTURE: 0.02,
    METALS_METALLURGY: 0.02,
    PAPER_PRINTING: 0.03,
    INDUSTRIAL_MACHINERY: 0.02,
    NON_METALLIC_MINERALS: 0.01,
    TEXTILE_APPAREL: 0.02,
    SOFTWARE_IT: 0.03,
    SOFTWARE_IT_DATACENTER: 0.02,
    AEROSPACE_DEFENSE: 0.02,
    OTHER: 0.02,
  },
  36: {
    OIL_GAS_PETROCHEMICAL: 0.02,
    RENEWABLE_ENERGY: 0.01,
    PLASTIC_RUBBER: 0.02,
    WOOD_FURNITURE: 0.02,
    AUTOMOTIVE_TRANSPORT: 0.02,
    PHARMA_BIOTECH_MEDICAL: 0.02,
    ELECTRONICS_HARDWARE: 0.02,
    CHEMICAL_PETROCHEMICAL: 0.02,
    FOOD_AGRICULTURE: 0.02,
    METALS_METALLURGY: 0.01,
    PAPER_PRINTING: 0.03,
    INDUSTRIAL_MACHINERY: 0.02,
    NON_METALLIC_MINERALS: 0.01,
    TEXTILE_APPAREL: 0.02,
    SOFTWARE_IT: 0.03,
    SOFTWARE_IT_DATACENTER: 0.02,
    AEROSPACE_DEFENSE: 0.02,
    OTHER: 0.02,
  },
};
